module.exports = __webpack_public_path__ + "img/noCompany2.f4bbff7d.png";